import qs from 'qs';
import { getMoveInDate } from './utils';

const buildUrl = (path) => {
  const baseUrl = new URL(process.env.OMI_API_URL);

  if (process.env.OMI_API_PORT) {
    baseUrl.port = process.env.OMI_API_PORT;
  }

  const { href: url } = new URL(path, baseUrl);
  return url;
};

export const buildAuthHeader = () => {
  if (process.env.AUTH_HEADER_TOKEN) {
    return `Basic ${process.env.AUTH_HEADER_TOKEN}`;
  }

  const token = btoa(
    `${process.env.OMI_API_KEY}:${process.env.OMI_API_SECRET}`,
  );
  return `Basic ${token}`;
};
export const getSource = () => {
  const source = sessionStorage.getItem('iSource');
  if (!source) {
    return 'sparefoot';
  }
  return source;
};

export const fetchConfiguration = (paylod) => fetch(buildUrl('config/configuration'), {
  method: 'POST',
  body: JSON.stringify(paylod),
  headers: {
    'Content-Type': 'application/json',
    Authorization: buildAuthHeader(),
    'X-Source': getSource(),

  },
}).then((response) => response.json());

export const fetchInitializationData = ({
  facilityId,
  providerId,
  organizationId,
  unitId,
  reservationId,
  returnUrl,
}) => {
  const pathParts = [
    `/providers/${providerId}`,
    `/organizations/${organizationId}`,
    `/facilities/${facilityId}`,
    `/units/${unitId}`,
    `?reservationAlias=${reservationId}`,
    `&returnUrl=${returnUrl}`,
  ];

  const url = buildUrl(pathParts.join(''));

  return fetch(url, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildAuthHeader(),
      'X-Source': getSource(),
    },
  });
};

export const fetchCostData = (
  { facilityId, unitId, moveInDate, reservationId, insurance, lock, cardNumber },
  insuranceKey,
  timezone,
  geo,
  invoicePeriod,
  facilityAlias,
) => {
  const body = {
    facilityId,
    unitId,
    moveInDate: getMoveInDate(moveInDate, timezone, geo),
    reservationId,
    cardNumber: cardNumber?.replace(/[\s-]/g, ''),
    facilityAlias,
  };
  body.fmsSpecificFields = {
    ...(insurance && {
      [insuranceKey]: insurance,
    }),
    ...(lock && {
      retailItems: [lock],
    }),
    invoicePeriod,
  };
  const url = buildUrl(`/costs?${qs.stringify(body, { encode: true })}`);

  return fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildAuthHeader(),
      'X-Source': getSource(),
    },
  });
};

export const updateContactData = ({ contact, password, fmsSpecificFields }) => fetch(buildUrl('/contacts/update'), {
  method: 'POST',
  headers: {
    'Content-Type': 'application/json',
    Authorization: buildAuthHeader(),
    'X-Source': getSource(),
  },
  body: JSON.stringify({
    contact: {
      contactId: contact.id,
      contactAlias: contact.alias,
      password,
      fmsSpecificFields,
    },
  }),
});

export const createRental = ({ reservationId, body }) => (
  fetch(buildUrl(`/reservations/${reservationId}/rentals`), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: buildAuthHeader(),
      'X-Source': getSource(),
    },
    body: JSON.stringify(body),
  })
);

export const sendLeaseConfirmationMail = ({
  rentalAlias,
  rentalId,
  companyId,
  configName,
  contactId,
  source,
  unitAlias,
  contactPhoneNumber,
  facilityPhoneNumber,
}) => {
  let url = `/rentals/${rentalAlias}/lease-agreement?rentalId=${rentalId}`;
  if (configName) {
    url = `${url}&configName=${configName}`;
  }
  if (source) {
    url = `${url}&source=${source}`;
  }
  if (contactId) {
    url = `${url}&contactId=${contactId}`;
  }
  if (companyId) {
    url = `${url}&companyId=${companyId}`;
  }
  if (unitAlias) {
    url = `${url}&unitAlias=${unitAlias}`;
  }
  if (contactPhoneNumber) {
    url = `${url}&contactPhoneNumber=${contactPhoneNumber}`;
  }
  if (facilityPhoneNumber) {
    url = `${url}&facilityPhoneNumber=${facilityPhoneNumber}`;
  }
  return fetch(
    buildUrl(url),
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: buildAuthHeader(),
        'X-Source': getSource(),
      },
    },
  );
};
